import React from "react";

const ComingSoon = () => {
  return (
    <div>
      <img src={"/comingSoon.svg"} alt='' className='img-fluid' />
    </div>
  );
};

export default ComingSoon;
